var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"services my-5 py-5"},[_c('card-group',{staticClass:"mt-5",attrs:{"isHome":false,"group-title":_vm.$t('title.all_services'),"services":_vm.templateServices,"all-services":true}}),_c('subscribe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }